import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=6b96ea5e&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports